import idx from 'idx';
import first from 'lodash/first';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrentRevision } from 'focus_groups/ducks/results';
import { withRouter } from 'react-router';

import ResultComments from 'focus_groups/components/result_comments';

export function mapStateToProps(state, { location }) {
  const revisions = idx(state, _ => _.project.focusGroups.viewState.currentGroup.revisions) || [];
  const currentRevisionId = idx(state, _ => _.project.focusGroups.results.currentRevisionId) || [];
  const revision = first(revisions.filter(({ id }) => (id === currentRevisionId))) || {};

  const showVotes = !!location.pathname.match(/(?:votes$)/);
  const showComments = !!location.pathname.match(/(?:comment$)/);

  return { ...revision, showVotes, showComments };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setCurrentRevision,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResultComments));



// WEBPACK FOOTER //
// ./focus_groups/containers/result_comments.js